export default "__VITE_ASSET__zhY8rb9G__"